import type { CanvasData, Element, Page, WorkspacePageLayoutMode } from '@/components/canvas/document/publicTypes';
import type { ParsedCanvasData } from '@/components/canvas/document/validation';

export function toCanvasData(
  pages: Page[],
  workspaceElements: Element[],
  schemaVersion = 1,
  viewport?: CanvasData['viewport'],
  workspacePageLayoutMode?: WorkspacePageLayoutMode,
): CanvasData {
  return {
    schemaVersion,
    pages,
    workspaceElements,
    ...(viewport ? { viewport } : {}),
    ...(workspacePageLayoutMode ? { workspacePageLayoutMode } : {}),
  };
}

/** 将 `parseCanvasData` 结果转为 `CanvasData`（保留布局模式与视口） */
export function canvasDataFromParsed(parsed: ParsedCanvasData): CanvasData {
  return toCanvasData(
    parsed.pages,
    parsed.workspaceElements,
    parsed.schemaVersion,
    parsed.viewport,
    parsed.workspacePageLayoutMode,
  );
}
